import axios from "../axios";

export async function deleteStorage(payload) {
  return axios
    .delete(`/inventory/storages/` + payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function createStorage(payload) {
  return axios
    .post(`/inventory/storages`, { inventory_storage: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateStorage(payload) {
  return axios
    .put(`/inventory/storages/` + payload.id, { inventory_storage: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchStorages() {
  return axios
    .get(`/inventory/storages`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Reject so pickers/thunks surface 403/network instead of an empty warehouse list.
      console.error("Error fetching storages:", error);
      const data = error.response?.data;
      if (data && typeof data === "object") {
        return Promise.reject({ ...data, status: error.response.status });
      }
      return Promise.reject(error);
    });
}

export async function fetchStorage(payload) {
  // payload is only ID
  return axios
    .get(`/inventory/storages/` + payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}
